import axios from 'axios';
import apiConfig from '../api.config';

export default function getPaymentsList() {
  const {
    host,
    URIs: { paymentsList },
  } = apiConfig;

  const uri = `${host}${paymentsList}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
